
import axios from "@/axios.js"

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/TraineeExamAnswer/AddTraineeExamAnswer", item)
        .then((response) => {
          commit('ADD_ITEM', Object.assign(item, { ID: response.data.ID }))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  submitTraineeExamAnswer(context, CourseClassExamQuestions) {
    debugger
    return new Promise((resolve, reject) => {
      axios.post("api/TraineeExamAnswer/SubmitTraineeExamAnswer", CourseClassExamQuestions)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  fetchDataListItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/TraineeExamAnswer/GetAll")
        .then((response) => {
          commit('SET_TraineeExamAnswers', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getTraineeExamsResult({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("api/TraineeExamAnswer/GetTraineeExamsResult")
        .then((response) => {
          commit('SET_ExamsResult', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  
  getTraineeExamsResultByTraineeID({ commit },ID) {
    
    return new Promise((resolve, reject) => {
      axios.get("api/TraineeExamAnswer/getTraineeExamsResultByTraineeID?ID="+ID)
        .then((response) => {
          commit('SET_ExamsResult', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put("api/TraineeExamAnswer/UpdateTraineeExamAnswer?ID="+item.ID, item)
        .then((response) => {
          
          commit('UPDATE_TraineeExamAnswer', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  MarkTextExam(context, item) {
    return new Promise((resolve, reject) => {
      axios.post("api/TraineeExamAnswer/MarkTextExam", item)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetItemByID( context,itemid) { 
    
    return new Promise((resolve, reject) => {
      axios.get("API/TraineeExamAnswer/GetTraineeExamAnswer?ID="+itemid)
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetTraineeExamsAnswerByTraineeID( {commit},data) { 
    
    return new Promise((resolve, reject) => {
      // axios.get("API/TraineeExamAnswer/GetTraineeExamsAnswerByTraineeID?traineeID="+data,ID,data.CourseClassID)
      axios.get("API/TraineeExamAnswer/GetTraineeExamsAnswerByTraineeID",
      {
        params:{
          traineeID:data.ID,
          courseClassID:data.CourseClassID,
          examID:data.ExamID
        }
      }
      )
        .then((response) => {
          commit('SET_TraineeExamAnswers', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  GetTraineeExamsAnswerByTraineeAndExam( {commit},data) { 
    
    return new Promise((resolve, reject) => {
      // axios.get("API/TraineeExamAnswer/GetTraineeExamsAnswerByTraineeID?traineeID="+data,ID,data.CourseClassID)
      axios.get("API/TraineeExamAnswer/GetTraineeExamsAnswerByTraineeAndExam",
      {
        params:{
          traineeID:data.TraineeID,
          courseClassID:data.CourseClassID,
          examID:data.ExamID
        }
      }
      )
        .then((response) => {
          debugger
          commit('SET_TraineeExamAnswers', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.delete("api/TraineeExamAnswer/DeleteTraineeExamAnswer?ID="+item.ID)
        .then((response) => {
          commit('REMOVE_ITEM', item.ID)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  getResultOFGeneralExam( context,Code) { 
    debugger
    return new Promise((resolve, reject) => {
      // axios.post("API/TraineeExamAnswer/getResultOFGeneralExam?Code="+Code)
      axios.get("API/TraineeExamAnswer/getResultOFGeneralExam", {
        params:{
          Code:Code
        }
      }
      )
        .then((response) => {
         
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}